import { FC } from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';
import { createBemBlockBuilder } from '@ebsco-ui/ebsco-ui';

import { ExternalLink } from '@app/components';
import { useBranding, useFeatureFlag } from '@app/hooks';
import { Feature } from '@app/constants';

import { LCFooterLinks } from './LCFooterLinks';
import { footerMessages } from './footerMessages';

import './Footer.scss';

const cnBem = createBemBlockBuilder(['footer']);

export const footerLinks = [
  {
    label: footerMessages.EBSCOHelp,
    path: 'https://connect.ebsco.com/s/article/Locate-Quick-Start-Guide?language=en_US',
  },
  {
    label: footerMessages.privacyPolicy,
    path: 'https://www.ebsco.com/company/privacy-policy/',
  },
  {
    label: footerMessages.termsOfUse,
    path: 'https://www.ebsco.com/license-agreement',
  },
];

export const Footer: FC = () => {
  const { $t } = useIntl();
  const { isActive: isLCFooterFlagActive } = useFeatureFlag({
    name: Feature.LCFooter,
  });

  const {
    copyrightNotice = $t(
      {
        id: 'footer.copyright',
        defaultMessage:
          '{year} EBSCO Information Services, Inc. All rights reserved',
      },
      { year: new Date().getFullYear() }
    ),
  } = useBranding();

  return (
    <footer className={cnBem()}>
      <div className={cnBem('__container')}>
        <nav
          className={cnBem('__navigation')}
          aria-label={$t(footerMessages.footerLinks)}
        >
          <LCFooterLinks />
          <ul
            data-auto="footer-navigation"
            className={cn({ general: isLCFooterFlagActive })}
          >
            {footerLinks.map(({ label, path }) => (
              <li key={path}>
                <ExternalLink href={path}>{$t(label)}</ExternalLink>
              </li>
            ))}
          </ul>
        </nav>
        <p className={cnBem('__copyright')} data-auto="copyright">
          {copyrightNotice}
        </p>
        {process.env.REACT_APP_VERSION && (
          <p className={cnBem('__appVersion')} data-auto="app-version">
            {$t(
              {
                id: 'appVersion',
                defaultMessage: 'Version {version}',
              },
              { version: process.env.REACT_APP_VERSION }
            )}
          </p>
        )}
      </div>
    </footer>
  );
};
